export
const name: string = "Defines";

export
const preproc: string = ``;

export
const declaration: string = `
    #define TEX_MODEL_NONE              0
    #define TEX_MODEL_MODULATE          1
    #define TEX_MODEL_CADWORK_MODULATE  2
    #define TEX_MODEL_BLEND             3
    #define TEX_MODEL_REPLACE           4


    #define SELECTED_MATERIAL_AMBIENT vec3(0.2)

    uniform vec3 u_selected_material_diffuse;

    struct SMaterial {
        lowp vec3  ambient;
        lowp vec3  diffuse;
        lowp vec3  specular;
        lowp vec3  emissive;
        lowp float transparency;
        lowp float shininess;
        lowp int   two_sided_lighting;
        lowp float alpha;
        lowp int   shading;
        lowp vec3  texColorReadOnly;
    };
`;

export
const varyings: string = `
    #if defined(XRAY)
    varying highp float       v_intensity;
    #endif
`;

export
const implementation: string = ``;
